import { render, staticRenderFns } from "./ProfileChangePassword.vue?vue&type=template&id=1b1ea722&scoped=true"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=js"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangePassword.vue?vue&type=style&index=0&id=1b1ea722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ea722",
  null
  
)

export default component.exports